export default {"src":"/_next/static/media/plus-new.77918dc3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};